import React, { useState, useEffect, memo } from 'react';
import { Box, Typography, Container } from '@mui/material';
import Wallpaper from '../assets/test2.gif';

const Corporate_identity = memo(() => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Container
      sx={{
        display: "flex",
        maxWidth: "none !important",
        width: "100%",
        height: "100vh",
        marginTop: "64px",
        backgroundImage: `url(${Wallpaper})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        paddingLeft: '0 !important'
      }}
    >
      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          opacity: isVisible ? 1 : 0,
          transition: "opacity 1s ease-in",
          textAlign: "left",
          color: 'white',
          backgroundColor: 'rgba(255, 255, 255, 0.3)',
          backdropFilter: 'blur(5px)',
        }}
      >
        <Typography variant="h3" gutterBottom  sx={{ marginLeft: '15px', fontWeight: 'bold', fontFamily: "'Noto Serif JP', serif" }}>
          あなたの物語を次の時代へ
        </Typography>
      </Box>

      <Box
        sx={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
      </Box>
    </Container>
  );
});

export default Corporate_identity;
